<template>
  <footer class="app-footer">
    <nav class="footer-links">
      <a href="https://otoeigo.com/privacy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>
      <span class="footer-sep">|</span>
      <a href="https://otoeigo.com/tokutei" target="_blank" rel="noopener noreferrer">特定商取引法に基づく表記</a>
      <span class="footer-sep">|</span>
      <a href="https://otoeigo.com/terms" target="_blank" rel="noopener noreferrer">利用規約</a>
    </nav>
    <p class="footer-copyright">© 2026 オトエイゴ / Otoeigo All Rights Reserved.</p>
  </footer>
</template>

<script setup>
</script>

<style scoped>
.app-footer {
  margin-top: auto;
  padding: 1rem 0.5rem 1.5rem;
  text-align: center;
  font-size: 0.7rem;
  color: #666;
  border-top: 1px solid #e2e8f0;
}

.footer-links {
  margin-bottom: 0.5rem;
}

.footer-links a {
  color: #667eea;
  text-decoration: none;
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-sep {
  margin: 0 0.4rem;
  color: #999;
}

.footer-copyright {
  margin: 0;
  font-size: 0.65rem;
  color: #888;
}
</style>
